import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';

import { TranscriptInsightsStructureResponse } from 'features/sessions/config/types';

export const useSessionNoteCustomStructureQueryActions = (
  insightStructureCode: string
) => {
  const queryClient = useQueryClient();

  const getCustomStructure = () => {
    return queryClient.getQueryData<TranscriptInsightsStructureResponse>([
      queryKeys.coachSessionTranscriptCustomStructure,
      insightStructureCode,
    ]);
  };

  const setCustomStructure = (
    customStructure: TranscriptInsightsStructureResponse
  ) => {
    return queryClient.setQueryData(
      [queryKeys.coachSessionTranscriptCustomStructure, insightStructureCode],
      customStructure
    );
  };

  const cancelQueries = () => {
    queryClient.cancelQueries([
      queryKeys.coachSessionTranscriptCustomStructure,
      insightStructureCode,
    ]);
  };

  const removeQueries = () => {
    queryClient.removeQueries([
      queryKeys.coachSessionTranscriptCustomStructure,
      insightStructureCode,
    ]);
  };

  return {
    getCustomStructure,
    setCustomStructure,
    cancelQueries,
    removeQueries,
  };
};
